<template>
  <div class="zixunyuyue">
    <!--预约窗口-->
    <div class="footer-yuyue-bar" :class="{'footer-yuyue-active':$parent.yyData.show}">
      <div class="yy-top-button" @click="$parent.yuYue({},false)">
        <span class="yy-top-button-left"></span><span class="yy-top-button-text">收起预约</span><span
        class="yy-top-button-right"></span>
      </div>
      <div class="yy-content">
        <div class="yy-full-content">
          <div class="yy-full-intro">
            <div class="yy-slogon">匠人匠心，展恒为您解决私募基金投资难题</div>
            <div class="yy-hot-line">400-818-8000</div>
          </div>
          <div class="yy-input-box">
            <div class="input-list">
              <input class="yy_name  placeholder" v-model="name" name="yy_name" type="text" id="yy_footer_name" value=""
                     placeholder="请输入您的真实姓名" maxlength="11">
              <input class="yy_phone  placeholder" name="yy_phone" v-model="phone"
                     type="text" id="yy_footer_phone" value="" placeholder="请输入您的手机号码" maxlength="11">
              <span id="yy-footer-submit-btn" @click="order">立即预约</span>
            </div>
            <div class="yy-tip">理财顾问将及时与您联系，为您提供专业投资咨询服务</div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="yy-tip-content">
          <div class="yy-tip-slogan">
            <i class="yy-icon-white-star"></i><i class="yy-icon-white-star"></i><i
            class="yy-icon-white-star"></i><span>证监会核准基金销售机构，13年行业品牌</span><i class="yy-icon-white-star"></i><i
            class="yy-icon-white-star"></i><i class="yy-icon-white-star"></i>
          </div>
          <div class="yy-tip-tel">400-680-3928</div>
        </div>
      </div>
    </div>
    <!--预约失败提示信息-->
    <div class="yuyueMes">
      <img src="https://www.myfund.com/images/zixunyuyue-bottom-tanchuang-error-icon.png" alt="" />
      <span id="word"></span>
    </div>
    <!--咨询预约成功提示信息-->
    <el-dialog  :visible.sync="yuyueSuccess" :show-close="false">
      <div class="demo" id="yuyueSuccess">
        <!-- 透明背景 -->
        <div class="demo-txt"><img src="https://www.myfund.com/images/grzx-right-icon.png"
                                   style="position:relative;right:15px;" /><span>预约成功</span></div>
        <!-- 不透明文字 -->
        <div class="demo-txt2">理财顾问将于1个工作日内与您联系，请保持手机畅通</div>
      </div>
    </el-dialog>
  </div>

</template>

<script>
    export default {
      name: "zixunYuyue",
      data(){
        return {
          name:'',//姓名
          phone:'',//手机号
          yuyueSuccess:false,
        }
      },
      methods:{
        order(){
          if(!this.$parent.yyData.wd.fundName) this.$message.success('暂未选中基金')
          let fundName = this.$parent.yyData.wd.fundName
        //fundName 基金名称
          var is_chinese = /^[\u2E80-\u9FFF]{2,10}$/;
          var isMobile = /^(?:13\d|15\d|18\d|14\d|16\d|17\d)\d{5}(\d{3}|\*{3})$/;
          const vm = this
          debugger
          if (this.name != "" && this.phone != "" && is_chinese.test(this.name) && isMobile.test(this.phone)) {
            vm.$http.get('https://apptrade.myfund.com:9091/appwebnew/ws/webapp-cxf/sendMailNew?title='+vm.phone+'&name='+vm.name+
            '&content=网站点击私募咨询预约，基金名称：'+fundName+'&email=khfw@myfp.cn',{}).then(res=>{
              console.log('发送是否成功',res)
              // vm.$message.success('预约成功')
              vm.yuyueSuccess = true
              setTimeout(()=>{
                vm.yuyueSuccess = false
              },2000)
            })
          } else if (!is_chinese.test(this.name)) {
            this.$message.error('请输入您的真实姓名')
          } else if (!isMobile.test(this.phone)) {
            this.$message.error('请输入您的手机号码')
          }
        }
      }
    }
</script>

<style scoped lang="less">
  .zixunyuyue {
    .footer-yuyue-active{
      bottom:0;
    }

  .footer-yuyue-bar {
    position: fixed;
    z-index: 500;
    bottom: -145px;
    left: 0;
    overflow: visible;
    width: 100%;
    height: 119px;
    -webkit-transition: all .3s;
    -moz-transition: all .3s;
    -ms-transition: all .3s;
    -o-transition: all .3s;
    transition: all .3s;
  }

  .footer-yuyue-active {
    bottom: 0;
  }

  .footer-yuyue-active * {
    font-size: 14px;
  }

  .footer-yuyue-bar .yy-content {
    overflow: hidden;
    width: 100%;
    height: 94px;
    background-color: #0C7AC1;
  }

  .footer-yuyue-bar .yy-full-content {
    overflow: hidden;
    width: 1202px;
    height: 94px;
    margin: 0 auto;
    padding-top: 22px;
    padding-left: 258px;
    -webkit-transition: height .1s;
    -moz-transition: height .1s;
    -ms-transition: height .1s;
    -o-transition: height .1s;
    transition: height .1s;
    background-image: url(https://www.myfund.com/images/zixunyuyue-bottom-phone-icon.png);
    background-repeat: no-repeat;
    background-position: 198px 25px;
  }

  .footer-yuyue-tip-active {
    height: 77px;
  }

  .footer-yuyue-bar .yy-icon-white-star {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin: -3px 3px 0;
    vertical-align: middle;
    background-image: url(http://www.simuwang.com//Public/Image/Data2/yuyue/icon-white-star.png);
    background-repeat: no-repeat;
  }

  .footer-yuyue-bar .yy-tip-content {
    display: none;
    overflow: hidden;
    width: 840px;
    height: 52px;
    margin: 0 auto;
    padding-top: 12px;
    font-size: 24px;
    line-height: 28px;
    color: #fff;
    *width: 850px;
  }

  .footer-yuyue-bar .yy-tip-content .yy-tip-slogan {
    float: left;
    width: 536px;
    height: 28px;
    margin-right: 29px;
    font-size: 20px;
    line-height: 28px;
    border-right: 1px solid #830101;
  }

  .footer-yuyue-bar .yy-tip-content .yy-tip-slogan span {
    padding: 0 20px;
  }

  .footer-yuyue-bar .yy-tip-content .yy-tip-tel {
    float: left;
    height: 28px;
    padding-left: 32px;
    font-size: 23px;
    line-height: 28px;
    color: #fff;
    background-image: url(http://www.simuwang.com//Public/Image/Data2/yuyue/icon-tel.png);
    background-repeat: no-repeat;
    background-position: left center;
  }

  .footer-yuyue-tip-active .yy-full-content {
    display: none;
  }

  .footer-yuyue-tip-active .yy-tip-content {
    display: block;
  }

  .footer-yuyue-bar .yy-full-content .yy-slogon {
    margin-bottom: 8px;
    font-size: 20px;
    line-height: 1;
    color: #fff;
  }

  .footer-yuyue-bar .yy-full-content .yy-hot-line {
    font-size: 20px;
    color: #fff;
  }

  .footer-yuyue-bar .yy-tip {
    line-height: 1;
    color: #fff;
    font-size: 14px;
  }

  .footer-yuyue-bar .yy-input-box input {
    float: left;
    width: 148px;
    height: 32px;
    margin-right: 12px;
    padding-left: 12px;
    font-size: 14px;
    line-height: 45px;
    color: #333;
    border-width: 0;
    border-radius: 4px;
    outline: none;
    *width: 174px;
  }

  .footer-yuyue-bar .yy-input-box .input-list {
    height: 45px;
  }

  .footer-yuyue-bar .yy-input-box .placeholder {
    color: #999;
  }

  .footer-yuyue-bar .yy-input-box #yy-footer-submit-btn {
    display: block;
    float: left;
    width: 90px;
    height: 34px;
    font-size: 14px;
    font-weight: bold;
    line-height: 34px;
    cursor: pointer;
    text-align: center;
    vertical-align: top;
    color: #fefefe;
    border-width: 0;
    border-radius: 4px;
    outline: none;
    background-color: #E74442;
  }

  .footer-yuyue-bar .yy-full-content .yy-full-intro {
    float: left;
    width: 400px;
    padding-left: 4px;
    margin-right: 16px;
  }

  .yy-top-button {
    position: relative;
    overflow: hidden;
    width: 110px;
    height: 25px;
    margin: 0 auto;
    font-size: 16px;
    line-height: 25px;
    cursor: pointer;
    text-align: center;
    color: #fff;
  }

  .yy-top-button .yy-top-button-left {
    position: absolute;
    left: 1px;
    top: 1px;
    width: 0;
    height: 0;
    border-bottom: 25px solid #0C7AC1;
    border-left: 15px solid transparent;
  }

  .yy-top-button .yy-top-button-right {
    position: absolute;
    right: 0;
    top:1px;
    width: 0;
    height: 0;
    border-right: 15px solid transparent;
    border-bottom: 25px solid #0C7AC1;
  }

  .yy-top-button .yy-top-button-text {
    display: inline-block;
    width: 80px;
    height: 25px;
    background-color: #0C7AC1;
  }

  #gr-szm-tip,
  .gr-login-error-tip3 {
    line-height: 1;
  }

  .layui-layer-shade {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /*_height: expression(document.body.offsetHeight+"px");*/
  }

  .layui-layer,
  .layui-layer-shade {
    position: fixed;
    _position: absolute;
    pointer-events: auto;
  }

  .layui-layer-content {
    overflow: hidden;
    background: #fff;
  }

  .error_box {
    position: relative;
    font-size: 18px;
    line-height: 115px;
    text-align: center;
    color: #333;
  }

  .error_box .layui-layer-close,
  .success_box .layui-layer-close,
  .yybox .layui-layer-close {
    position: absolute;
    top: 13px;
    right: 13px;
    width: 22px;
    height: 22px;
    cursor: pointer;
    background-image: url(http://www.simuwang.com//Public/Image/Data2/yuyue/icon-close.png);
    background-repeat: no-repeat;
    background-position: left center;
  }

  .success_box .success_title {
    margin-top: 48px;
    margin-bottom: 14px;
    font-size: 22px;
    font-weight: 600;
    line-height: 34px;
    text-align: center;
    color: #333;
  }

  .success_box .success_msg {
    font-size: 18px;
    line-height: 1;
    text-align: center;
    color: #333;
  }

  .yuyueMes {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 294px;
    height: 102px;
    background: #fff;
    margin-top: -51px;
    margin-left: -147px;
    z-index: 9999;
    display: none;
  }

  .yuyueMes img {
    position: absolute;
    top: 36px;
    left: 37px;
  }

  .yuyueMes #word {
    position: absolute;
    left: 78px;
    top: 36px;
    color: #dd0303;
    font-weight: bold;
    font-size: 20px;
  }
    /deep/ .el-dialog{
      width: 426px;
      height: 102px;
      margin-top: 30vh !important;
    }
    /deep/ .el-dialog__header{
      display: none;
    }
    /deep/ .el-dialog__body{
      padding:8px 0;
    }

  .demo{
    width: 426px;
    height: 102px;
    /*position: fixed;*/
    /*top: 50%;*/
    /*margin-top: -60px;*/
    /*left: 50%;*/
    /*margin-left: -150px;*/
    /*z-index: 9999;*/
  }

  .demo-bg {
    /*position: absolute;*/
    /*left: 0;*/
    /*top: 0;*/
    /*z-index: 0;*/
    /*width: 426px;*/
    /*height: 102px;*/
    /*background-color: #fff;*/
    /*border-radius: 5px;*/
    /*-moz-border-radius: 2px;*/
  }

  .demo-txt {
    position: relative;
    z-index: 1;
    color: #00AF0C;
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    letter-spacing: 5px;
    margin-bottom: 20px;
    padding-top: 15px;
  }

  .demo-txt2 {
    position: relative;
    z-index: 1;
    color: #333;
    font-size: 16px;
    text-align: center;
    line-height: 8px;
  }

  #bg {
    position: absolute;
    top: 0%;
    left: 0%;
    width: 100%;
    height: 3464px;
    background-color: black;
    z-index: 1001;
    -moz-opacity: 0.7;
    opacity: .70;
    filter: alpha(opacity=70);
  }

  }
</style>
